import React, { memo } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { TaskFilters as Filters, ChangeTaskFilter } from 'entities/task';
import { Checkbox, Icon, UiButton } from 'shared/ui';

import cls from './FilterType.module.css';
import { TasksTypes, useFilterType } from '../../lib/hooks/useFilterType';
import { SelectedFilter } from '../../lib/hooks/useTaskExtraFilters';

interface FilterTypeProps {
    classes?: string;
    isShow: boolean;
    onSelectedFilter: (value: SelectedFilter) => void;
    onFilteredData: ChangeTaskFilter;
    filteredData: Filters;
}

export const FilterType = memo(
    ({
        classes,
        onSelectedFilter,
        isShow,
        onFilteredData,
        filteredData,
    }: FilterTypeProps) => {
        const { onChangeCheckbox, isActiveTypesFilter, resetFilterTypes, selectedItemText } =
            useFilterType(onFilteredData, filteredData);

        const { t } = useTranslation();

        return (
            <div
                className={classNames(cls.FilterType, [classes], {
                    [cls.open]: isShow,
                })}
            >
                <div
                    className={classNames(cls.header)}
                    onClick={() => onSelectedFilter(isShow ? null : 'type')}
                >
                    <div className={cls.iconWrapper}>
                        <Icon iconName="taskTypes" />
                    </div>
                    {isActiveTypesFilter ? (
                        <div className={cls.selectedItem}>
                            <span>{selectedItemText}</span>
                        </div>
                    ) : (
                        <div className={cls.placeholder}>
                            {t('FilterType.return.FilterType.placeholder')}
                        </div>
                    )}
                    {isActiveTypesFilter ? (
                        <UiButton
                            onClick={resetFilterTypes}
                            className={cls.resetIcon}
                            variant="icon"
                            startIcon={<Icon iconName="resetInput" />}
                        />
                    ) : (
                        <div
                            className={classNames(cls.arrow, {
                                [cls.openArrow]: isShow,
                            })}
                        >
                            <Icon iconName="selectArrow" />
                        </div>
                    )}
                </div>
                <div className={classNames(cls.types)}>
                    <div className={cls.typeItem} onClick={onChangeCheckbox(TasksTypes.CUSTOM)}>
                        <Checkbox
                            classes={cls.checkbox}
                            isActive={filteredData.type.includes(TasksTypes.CUSTOM)}
                            title={t('useFilterType.getSelectedItemText.typesMapping.CUSTOM')}
                            isDisabled={
                                filteredData.type.length === 1 &&
                                filteredData.type.includes(TasksTypes.CUSTOM)
                            }
                        />
                    </div>
                    <div className={cls.typeItem} onClick={onChangeCheckbox(TasksTypes.PAYMENT)}>
                        <Checkbox
                            classes={cls.checkbox}
                            isActive={filteredData.type.includes(TasksTypes.PAYMENT)}
                            title={t('useFilterType.getSelectedItemText.typesMapping.PAYMENT')}
                            isDisabled={
                                filteredData.type.length === 1 &&
                                filteredData.type.includes(TasksTypes.PAYMENT)
                            }
                        />
                    </div>
                    <div
                        className={cls.typeItem}
                        onClick={onChangeCheckbox(TasksTypes.SUPPLY_REQUEST)}
                    >
                        <Checkbox
                            classes={cls.checkbox}
                            isActive={filteredData.type.includes(TasksTypes.SUPPLY_REQUEST)}
                            title={t(
                                'useFilterType.getSelectedItemText.typesMapping.SUPPLY_REQUEST'
                            )}
                            isDisabled={
                                filteredData.type.length === 1 &&
                                filteredData.type.includes(TasksTypes.SUPPLY_REQUEST)
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }
);
